import React from 'react';
import './index.scss';
import { Modal } from 'antd';

export interface FileListItem {
  uid: string;
  type: 'image' | 'video' | 'other';
  url: string;
  fileKey?: string;
  name?: string;
}
export interface PreviewListProps {
  fileList: FileListItem[];
  onDelete?: AnyFunc;
  onPreview?: AnyFunc;
  fill?: boolean;
  showPreviewName?: boolean; //是否显示预览文件名称（上方预览文件或文件，下方显示预览文件名称）false将不展示下方的名称
}

const PreviewList = (props: PreviewListProps) => {
  return (
    <ul
      className={
        props.fill
          ? 'preview-list preview-list-width-100'
          : 'preview-list preview-list-width-70'
      }
    >
      {props.fileList.map((item: FileListItem) => {
        return (
          <li
            className="file-preview-item"
            style={
              props.showPreviewName ? { height: '60px' } : { height: '40px' }
            }
            key={item.uid}
          >
            <>
              <div className="preview-item">
                {item.type === 'image' ? (
                  <img className="file-item" src={item.url} alt="" />
                ) : item.type === 'video' ? (
                  <video
                    className="file-item"
                    style={{ background: '#000' }}
                    src={item.url}
                  />
                ) : (
                  <a className="file-item" href={item.url}>
                    {item.name}
                  </a>
                )}
                {props.showPreviewName && (
                  <div className="file-item-desc">{item.name}</div>
                )}
              </div>
              <div className="preview-mask">
                {props.onPreview && (
                  <span
                    onClick={() => {
                      Modal.info({
                        title: '文件预览',
                        width: 800,
                        footer: null,
                        closable: true,
                        content: (
                          <>
                            {item.type === 'image' ? (
                              <img
                                className="file-item"
                                src={item.url}
                                alt=""
                                style={{
                                  width: '100%',
                                  height: '600px',
                                }}
                              />
                            ) : (
                              <video
                                style={{
                                  width: '100%',
                                  height: '600px',
                                }}
                                controls
                                className="file-item"
                                src={item.url}
                              />
                            )}
                          </>
                        ),
                      });
                      props.onPreview && props.onPreview(item);
                    }}
                    role="img"
                    aria-label="eye"
                    className="anticon anticon-eye"
                  ></span>
                )}
                {props.onDelete && (
                  <span
                    onClick={props.onDelete.bind(null, item)}
                    role="img"
                    aria-label="delete"
                    className="anticon anticon-delete"
                  ></span>
                )}
              </div>
            </>
          </li>
        );
      })}
    </ul>
  );
};

export default React.memo(PreviewList);
